import { render, staticRenderFns } from "./TooltipOnElement.vue?vue&type=template&id=04227482&scoped=true&"
import script from "./TooltipOnElement.vue?vue&type=script&lang=js&"
export * from "./TooltipOnElement.vue?vue&type=script&lang=js&"
import style0 from "./TooltipOnElement.vue?vue&type=style&index=0&id=04227482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04227482",
  null
  
)

export default component.exports